// Cloudinary Configuration for Image Uploads and Display
// You'll need to get these values from your Cloudinary dashboard

import { Cloudinary } from '@cloudinary/url-gen';

export const cloudinaryConfig = {
  cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'demo',
  apiKey: process.env.REACT_APP_CLOUDINARY_API_KEY || '',
  apiSecret: process.env.REACT_APP_CLOUDINARY_API_SECRET || '', // Not used in frontend uploads
  uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'nortiq-blog'
};

// Initialize Cloudinary instance for URL generation
export const cld = new Cloudinary({ 
  cloud: { 
    cloudName: cloudinaryConfig.cloudName 
  } 
});

// Upload function for images
export const uploadImageToCloudinary = async (file: File): Promise<string> => {
  console.log('🚀 Starting Cloudinary upload...');
  console.log('📁 File:', file.name, file.size, file.type);
  console.log('☁️ Cloud Name:', cloudinaryConfig.cloudName);
  console.log('🔧 Upload Preset:', cloudinaryConfig.uploadPreset);
  
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', cloudinaryConfig.uploadPreset);
  formData.append('cloud_name', cloudinaryConfig.cloudName);

  const uploadUrl = `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloudName}/image/upload`;
  console.log('🌐 Upload URL:', uploadUrl);

  try {
    console.log('📤 Sending request to Cloudinary...');
    const response = await fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    });

    console.log('📥 Response status:', response.status, response.statusText);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Cloudinary error response:', errorText);
      throw new Error(`Failed to upload image to Cloudinary: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('✅ Upload successful! URL:', data.secure_url);
    return data.secure_url; // Returns the HTTPS URL of the uploaded image
  } catch (error) {
    console.error('💥 Error uploading image to Cloudinary:', error);
    throw error;
  }
};

// Helper function to generate optimized image URLs
export const getOptimizedImageUrl = (publicId: string, options: {
  width?: number;
  height?: number;
  quality?: 'auto' | number;
  format?: 'auto' | 'webp' | 'jpg' | 'png';
} = {}) => {
  const { width, height, quality = 'auto', format = 'auto' } = options;
  
  let transformations = [];
  
  if (width) transformations.push(`w_${width}`);
  if (height) transformations.push(`h_${height}`);
  if (quality) transformations.push(`q_${quality}`);
  if (format) transformations.push(`f_${format}`);
  
  const transformString = transformations.length > 0 ? `${transformations.join(',')}/` : '';
  
  return `https://res.cloudinary.com/${cloudinaryConfig.cloudName}/image/upload/${transformString}${publicId}`;
};
